<template>
  <div class="root">
    <v-container>
      <v-row class="spacing6">
        <v-col md="6" class="pa-6">
          <title-main :align="isMobile ? 'center' : 'left'">
            <strong>Kontakt</strong>
          </title-main>
          <p class="text use-text-subtitle2" :class="[isMobile ? 'text-center' : 'text-left']">
            Soovid lisainfot?
          </p>
          <div class="my-2">
            <a href="tel:+37256570441" class="link black--text use-text-subtitle2">
              <v-icon left>mdi-phone</v-icon>
              <span class="grey--text">+372</span>
              56 570 441
            </a>
          </div>
          <div class="d-flex align-center my-2">
            <a href="mailto:bookus@bookus.live" class="link black--text use-text-subtitle2">
              <v-icon left>mdi-email</v-icon>
              bookus@bookus.live
            </a>
          </div>
          <hidden point="smDown">
            <div class="illustration">
              <!-- <parallax-medium /> -->
              <img :src="$asset('images/saas/faq.png')" alt="illustration" />
            </div>
          </hidden>
        </v-col>
        <v-col md="6" cols="12" class="pa-6">
          <div class="accordion">
            <v-expansion-panels v-model="panel" active-class="expanded">
              <v-expansion-panel v-for="(item, index) in items" :key="index" class="paper">
                <v-expansion-panel-header class="content">
                  <p class="heading">
                    {{ item.q }}
                  </p>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="detail">
                  <p>
                    {{ item.a }}
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "faq-style.scss";
</style>

<script>
// import Hidden from "../Hidden";
import ParallaxMedium from "../Parallax/Medium";
import Title from "../MainTitle";

const demoFaqs = [
  {
    q: "Pellentesque ac bibendum tortor?",
    a: "Vivamus sit amet interdum elit. Proin lacinia erat ac velit tempus auctor.",
  },
  {
    q: "In mi nulla, fringilla vestibulum?",
    a: "Vivamus sit amet interdum elit. Proin lacinia erat ac velit tempus auctor. ",
  },
  {
    q: "Quisque lacinia purus ut libero?",
    a: "Vivamus sit amet interdum elit. Proin lacinia erat ac velit tempus auctor. ",
  },
  {
    q: "Quisque ut metus sit amet augue?",
    a: "Vivamus sit amet interdum elit. Proin lacinia erat ac velit tempus auctor. ",
  },
  {
    q: "Pellentesque ac bibendum tortor?",
    a: "Vivamus sit amet interdum elit. Proin lacinia erat ac velit tempus auctor. ",
  },
];

export default {
  components: {
    // Hidden,
    ParallaxMedium,
    "title-main": Title,
  },
  props: {
    items: {
      type: Array,
      default: demoFaqs,
    },
  },
  data() {
    return {
      panel: 0,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
      //   const smDown = this.$store.state.breakpoints.smDown;
      //   return smDown.indexOf(this.$mq) > -1;
    },
  },
};
</script>
